import { create } from 'zustand';
import { Dayjs } from 'dayjs';
import { Shift } from '@libs/models/shifts';
import { StaffListItem } from '@libs/models/talents/talent';

type InitialState = {
  open: boolean;
  loading: boolean;
  currentProviderInfo: StaffListItem | null;
  providerAssignments: Shift[];
  day: Dayjs | null;

  openDrawer: (provider: StaffListItem, assignments: Shift[], day: Dayjs) => void;
  closeDrawer: () => void;
};

export const useAssignShiftDrawerStore = create<InitialState>()((set) => ({
  open: false,
  loading: false,
  currentProviderInfo: null,
  providerAssignments: [],
  day: null,

  openDrawer: (provider, assignments, day) => {
    set({ open: true, currentProviderInfo: provider, day, providerAssignments: assignments });
  },
  closeDrawer: () => {
    set({ open: false, currentProviderInfo: null, day: null, providerAssignments: [] });
  },
}));
